import { render, staticRenderFns } from "./HomeSidebar.vue?vue&type=template&id=34721c2e&scoped=true&"
import script from "./HomeSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./HomeSidebar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34721c2e",
  null
  
)

export default component.exports